import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A Controller used to setup the operator binding with the associated operator summary view
 */
export class OperatorSummaryController {
  public static $inject = [
    'operator',
    'PrimaryAction',
    '$state',
    'breadcrumbService'
  ];

  constructor(
    public operator: InterACT.Interfaces.TransportOperators.TransportOperator,
    private PrimaryAction: any,
    private $state: ng.ui.IStateService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.activate();
  }

  public goToEdit = () => {
    this.$state.go('operator.edit');
  }

  private activate() {
    this.PrimaryAction.setActions([{
      name: 'Edit Operator',
      icon: 'mode_edit',
      action: this.goToEdit
    }]);
    this.breadcrumbService.setBreadcrumbs([
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.OPERATORS',
        sref: 'operators'
      },
      {
        name: 'BREADCRUMBS.REIMBURSEMENT.OPERATORS.SUMMARY',
        sref: 'operator.summary'
      }
    ]);
  }
}